<template>
  <div class="role-display">
    <!-- Current Role Display -->
    <div class="current-role-badge" :class="getRoleClass(currentRole)">
      <i :class="getRoleIcon(currentRole)"></i>
      <span class="role-text">{{ formatRoleName(currentRole) }}</span>
      
      <!-- Role Switch Button (if user has multiple roles) -->
      <el-button 
        v-if="canSwitchRoles"
        type="text" 
        size="mini"
        class="switch-role-btn"
        @click="showRoleSwitcher"
        icon="el-icon-refresh"
      >
      </el-button>
    </div>
    

  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'RoleDisplay',
  computed: {
    ...mapState(['userRoles', 'activeRole']),
    ...mapGetters(['currentRole']),
    
    availableRoles() {
      if (Array.isArray(this.userRoles)) {
        return this.userRoles
      }
      return []
    },
    
    canSwitchRoles() {
      return this.availableRoles.length > 1
    }
  },
  
  methods: {
    ...mapActions(['setActiveRole']),
    
    formatRoleName(role) {
      if (!role) return 'No Role'
      return role.replace('ROLE_', '').replace('_', ' ').toLowerCase()
        .replace(/\b\w/g, l => l.toUpperCase())
    },
    
    getRoleIcon(role) {
      const icons = {
        'ROLE_ADMIN': 'el-icon-s-tools',
        'ROLE_CURATOR': 'el-icon-edit-outline',
        'ROLE_EMPLOYEE': 'el-icon-user',
        'ROLE_MANAGER': 'el-icon-s-management',
        'ROLE_SUPERVISOR': 'el-icon-view'
      }
      return icons[role] || 'el-icon-user-solid'
    },
    
    getRoleClass(role) {
      const classes = {
        'ROLE_ADMIN': 'role-admin',
        'ROLE_CURATOR': 'role-curator',
        'ROLE_EMPLOYEE': 'role-employee',
        'ROLE_MANAGER': 'role-manager',
        'ROLE_SUPERVISOR': 'role-supervisor'
      }
      return classes[role] || 'role-default'
    },
    
    showRoleSwitcher() {
      // Emit event to parent to show role selector modal instead of dropdown
      this.$emit('show-role-selector')
    }
  }
}
</script>

<style scoped>
.role-display {
  position: relative;
  display: inline-block;
}

.current-role-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  color: white;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.role-admin {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);
}

.role-curator {
  background: linear-gradient(135deg, #4834d4 0%, #686de0 100%);
}

.role-employee {
  background: linear-gradient(135deg, #00d2d3 0%, #54a0ff 100%);
}

.role-manager {
  background: linear-gradient(135deg, #ff9ff3 0%, #f368e0 100%);
}

.role-supervisor {
  background: linear-gradient(135deg, #feca57 0%, #ff9f43 100%);
}

.role-default {
  background: linear-gradient(135deg, #a4b0be 0%, #747d8c 100%);
}

.role-text {
  margin-left: 6px;
  margin-right: 4px;
}

.switch-role-btn {
  padding: 0 !important;
  margin-left: 4px;
  color: white !important;
  font-size: 12px;
}

.switch-role-btn:hover {
  background: rgba(255, 255, 255, 0.2) !important;
  border-radius: 50%;
}


</style>
